// Angular Imports
import { ChangeDetectionStrategy, Component, Input, booleanAttribute } from '@angular/core'
import { NgOptimizedImage } from '@angular/common'

@Component({
	standalone: true,
	selector: 'app-image',
	imports: [NgOptimizedImage],
	templateUrl: './image.component.html',
	styleUrl: './image.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageComponent {
	@Input({ required: true }) src!: string
	@Input({ required: true }) alt!: string
	@Input({ transform: booleanAttribute }) priority: boolean = false
	@Input() width: string = '100%'
	@Input() height: string = '100%'
}
